module.exports = __webpack_public_path__ + "img/if_13.927349d2.png";